import React, { createContext, useContext } from 'react';

const TopmenuContext = createContext({
  transparent: false,
});

const useTopmenuProvider = () => useContext(TopmenuContext);

const TopmenuProvider = ({ transparent, children }: { transparent: boolean, children: any }) => (
  <TopmenuContext.Provider value={{ transparent }}>{children}</TopmenuContext.Provider>
);

export { useTopmenuProvider };
export default TopmenuProvider;
